import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-avatar-list',
  templateUrl: './avatar-list.component.html',
  styleUrls: ['./avatar-list.component.less']
})
export class AvatarListComponent extends SkeletonSizeBase implements OnInit {
  @Input() showImg;
  @Input() multiLines;
  @Input() currentImg;
  @Input() avatarImgSrc;
  constructor() {
    super();
  }

  ngOnInit() {}
}
